import { Controller } from "stimulus";

import $ from "jquery";

/**
 * Provides some functionality to manage the showing/hiding of targets depending on a "loading" state, determined by the
 * extending controller.
 */
export default class extends Controller {
  static targets = ["contentWrapper", "loading", "loadError"];

  isLoading() {
    this.hideContent();
    this.hideLoadError();

    this.showLoading();
  }

  isLoaded() {
    this.hideLoading();
    this.hideLoadError();

    this.showContent();
  }

  isErrored() {
    this.hideLoading();
    this.hideContent();

    this.showLoadError();
  }

  showContent() {
    this.showTargets(this.contentWrapperTarget);
  }

  hideContent() {
    this.hideTargets(this.contentWrapperTarget);
  }

  showLoading() {
    this.showTargets(...this.loadingTargets);
  }

  hideLoading() {
    this.hideTargets(...this.loadingTargets);
  }

  showLoadError() {
    this.showTargets(...this.loadErrorTargets);
  }

  hideLoadError() {
    this.hideTargets(...this.loadErrorTargets);
  }

  hideTargets(...targets) {
    targets.forEach((target) => $(target).hide());
  }

  showTargets(...targets) {
    targets.forEach((target) => $(target).show());
  }
}
